// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwImageCell from 'viewmodel/AwImageCellViewModel';
import DesCompactImageCell from 'viewmodel/DesCompactImageCellViewModel';
import DesCatalogCustomCell from 'viewmodel/DesCatalogCustomCellViewModel';
    import { ExistWhen } from 'js/hocCollection';
const DivExistWhen = ExistWhen('div');
DivExistWhen.displayName = 'DivExistWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesCatalogPartListService', () => import('js/DesCatalogPartListService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/DesCatalogImagesViewService', () => import('js/DesCatalogImagesViewService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "constants": {
            "REGULAR": "regular",
            "COMPACT": "compact",
            "CUSTOM": "custom"
        },
        "showPartSummary": false,
        "pathForSelectedPart": "",
        "facetFilter": [],
        "desTotalCount": 0,
        "selectedcontentPath": "",
        "featureGroupId": "{{props.contentpath}}",
        "resetAttributes": false
    },
    "lifecycleHooks": {
        "onUpdate": [
            {
                "action": "performBatchActionOnUpdate",
                "observers": [
                    "props.accsessionid",
                    "props.catalogspaceid",
                    "props.provider",
                    "props.contentpath",
                    "props.display",
                    "props.locale",
                    "props.limit",
                    "props.filterStatus"
                ]
            }
        ],
        "onUnmount": "disconnectIntersectionObserver"
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "catalogspaceid": {
            "type": "string"
        },
        "provider": {
            "type": "string"
        },
        "display": {
            "type": "string"
        },
        "contentpath": {
            "type": "string"
        },
        "limit": {
            "type": "int"
        },
        "locale": {
            "type": "string"
        },
        "filterStatus": {
            "type": "string"
        }
    },
    "actions": {
        "performBatchActionOnUpdate": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "setFeatureGroupId"
                },
                {
                    "action": "reveal"
                }
            ]
        },
        "setFeatureGroupId": {
            "actionType": "JSFunction",
            "method": "setFeatureGroupId",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogPartListService"
        },
        "reveal": {
            "actionType": "dataProvider",
            "method": "catalogParts"
        },
        "loadData": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "appBaseUrl": "assets",
                        "additionalProperties": {
                            "provider": "{{props.provider}}",
                            "desTotalCount": "{{data.desTotalCount}}",
                            "hasMore": "{{data.hasMore}}",
                            "filterStatus": "{{props.filterStatus}}"
                        },
                        "query": "query SearchObjects( $from: Int, $size: Int, $catalogspaceId: String, $featureGroupId: String, $locale: String ) {searchObjects( from: $from, size: $size, catalogspaceId: $catalogspaceId, featureGroupId: $featureGroupId, locale: $locale )}",
                        "variables": {
                            "from": "{{data.desTotalCount}}",
                            "size": "{{props.limit}}",
                            "catalogspaceId": "{{props.catalogspaceid}}",
                            "featureGroupId": "{{data.data.featureGroupId}}",
                            "locale": "{{props.locale}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "searchObjects": "data.data.searchObjects.searchObjs",
                "totalCount": "data.data.searchObjects.totalCount",
                "facets": "data.data.searchObjects.facets[0].buckets",
                "hasMore": "data.data.searchObjects.hasMore",
                "desTotalCount": "data.data.searchObjects.desTotalCount"
            },
            "events": {
                "success": [
                    {
                        "name": "getPartList.success"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "getSelectedPart": {
            "actionType": "JSFunction",
            "method": "getSelectedPart",
            "inputData": {
                "vmo": "{{data}}",
                "selectedPart": "{{eventData.selectedObjects}}"
            },
            "deps": "js/DesCatalogPartListService"
        },
        "performBatchActionForSelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "getSelectedPart",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "setContentPath": {
            "actionType": "JSFunction",
            "method": "setPartListContentPath",
            "inputData": {
                "vmo": "{{data}}",
                "selectedFacetFilter": "{{parameters.selectedNavigateFolderPath}}"
            },
            "deps": "js/DesCatalogPartListService"
        },
        "performBatchAction": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "setContentPath"
                },
                {
                    "action": "reveal"
                }
            ]
        },
        "initIntersectionObserver": {
            "actionType": "JSFunction",
            "method": "initIntersectionObserver",
            "inputData": {
                "imageObjects": "{{data.searchObjects}}",
                "provider": "{{props.provider}}",
                "acc": "des-catalog-part-list",
                "vmo": "{{data}}",
                "display": "{{props.display}}"
            },
            "deps": "js/DesCatalogImagesViewService"
        },
        "disconnectIntersectionObserver": {
            "actionType": "JSFunction",
            "method": "disconnectIntersectionObserver",
            "deps": "js/DesCatalogImagesViewService"
        },
        "setTimeoutForContentShouldLoadInDOM": {
            "actionType": "JSFunctionAsync",
            "method": "setTimeoutForContentShouldLoadInDOM",
            "inputData": {
                "timeout": 50
            },
            "deps": "js/DesCatalogPartListService"
        },
        "getPartListSuccessBatchJob": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "setTimeoutForContentShouldLoadInDOM"
                },
                {
                    "action": "initIntersectionObserver"
                }
            ]
        }
    },
    "dataProviders": {
        "catalogParts": {
            "action": "loadData",
            "response": "{{data.searchObjects}}",
            "totalFound": "{{data.totalCount}}"
        }
    },
    "onEvent": [
        {
            "eventId": "catalogParts.selectionChangeEvent",
            "cacheEventData": true,
            "action": "performBatchActionForSelection",
            "inputArgs": {
                "eventName": "desCatalogPartSelectionChange",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "navigationTreeProvider.selectionChangeEvent",
            "action": "performBatchAction",
            "cacheEventData": false,
            "inputArgs": {
                "eventName": "navigationTreeProvider.selectionChangeEvent",
                "selectedNavigateFolderPath": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "des-refreshPartsList",
            "action": "performBatchAction",
            "inputArgs": {
                "eventName": "des-refreshPartsList",
                "selectedNavigateFolderPath": "{{eventData}}"
            }
        },
        {
            "eventId": "getPartList.success",
            "action": "getPartListSuccessBatchJob"
        }
    ],
    "conditions": {
        "displayRegularView": {
            "expression": "props.display === data.constants.REGULAR"
        },
        "displayCompactView": {
            "expression": "props.display === data.constants.COMPACT"
        },
        "displayCustomView": {
            "expression": "props.display === data.constants.CUSTOM"
        }
    },
    "_viewModelId": "DesCatalogPartList",
    "_uniqueViewModelId": "DesCatalogPartList",
    "ctx": {}
};

    /*
    <div exist-when="conditions.displayRegularView" class="des-catalog-PartList-Content des-catalog-PartList-Style des-display-regular" style="height:100%;">
    <aw-panel class="h-12">
        <aw-panel-body>
            <aw-list has-floating-cell-commands="false" dataprovider="dataProviders.catalogParts">
                <aw-image-cell vmo="item"></aw-image-cell>
            </aw-list>
        </aw-panel-body>
    </aw-panel>
</div>

<div exist-when="conditions.displayCompactView" class="des-catalog-PartList-Content des-catalog-PartList-Style" style="height:100%;">
    <aw-panel class="h-12">
        <aw-panel-body>
            <aw-list has-floating-cell-commands="false" dataprovider="dataProviders.catalogParts">
                <des-compact-image-cell vmo="item"></des-compact-image-cell>
            </aw-list>
        </aw-panel-body>
    </aw-panel>
</div>

<div exist-when="conditions.displayCustomView" class="des-catalog-PartList-Content des-catalog-PartList-Style" style="height:100%;">
    <aw-panel class="h-12">
        <aw-panel-body>
            <aw-list has-floating-cell-commands="false" dataprovider="dataProviders.catalogParts">
                <des-catalog-custom-cell vmo="item"></des-catalog-custom-cell>
            </aw-list>
        </aw-panel-body>
    </aw-panel>
</div>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
            <Fragment>
    <DivExistWhen className="des-catalog-PartList-Content des-catalog-PartList-Style des-display-regular" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayRegularView" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwPanel  revealAction={actions.reveal}  className="h-12">
            <AwPanelBody>
                <AwList dataprovider={dataProviders.catalogParts} showDropArea={null} hasFloatingCellCommands={false} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <AwImageCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </AwImageCell></> } }
                </AwList>
            </AwPanelBody>
        </AwPanel>
    </DivExistWhen>
    <DivExistWhen className="des-catalog-PartList-Content des-catalog-PartList-Style" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayCompactView" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwPanel  revealAction={actions.reveal}  className="h-12">
            <AwPanelBody>
                <AwList dataprovider={dataProviders.catalogParts} showDropArea={null} hasFloatingCellCommands={false} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <DesCompactImageCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </DesCompactImageCell></> } }
                </AwList>
            </AwPanelBody>
        </AwPanel>
    </DivExistWhen>
    <DivExistWhen className="des-catalog-PartList-Content des-catalog-PartList-Style" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayCustomView" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwPanel  revealAction={actions.reveal}  className="h-12">
            <AwPanelBody>
                <AwList dataprovider={dataProviders.catalogParts} showDropArea={null} hasFloatingCellCommands={false} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <DesCatalogCustomCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </DesCatalogCustomCell></> } }
                </AwList>
            </AwPanelBody>
        </AwPanel>
    </DivExistWhen>
</Fragment>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;